import { IconUserCancel } from '@tabler/icons-react';
import React from 'react';
import { Scope } from 'src/data/scopes';
import { Center } from 'src/design/atoms/Center';
import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { TagBadgeList } from 'src/design/molecules/TagBadgeList';

export interface IAccessDeniedProps {
  requiredScopes: Scope[];
}

/** @registry Full-page "you don't have permission" panel listing the scopes required for the current route. */
export const AccessDenied: React.FC<IAccessDeniedProps> = ({
  requiredScopes,
}) => {
  return (
    <SimpleGrid cols={1} mt="xl">
      <Center p="xl">
        <Stack align="center" gap="md">
          <IconUserCancel size={54} color="var(--mantine-color-gray-6)" />
          <Title order={3}>Access Denied</Title>
          <Text ta="center">
            You do not have the correct permissions to view this page. Please
            request access from your administrator
          </Text>
          <Stack align="center" gap="sm" mt="md">
            <Title order={5}>
              This page requires at least one of the following scopes:
            </Title>
            <TagBadgeList tags={requiredScopes} />
          </Stack>
        </Stack>
      </Center>
    </SimpleGrid>
  );
};
